export default __webpack_public_path__ + "static/block-green-514f10e642ec53b8d6ee17ac1a14e88e.svg";